import { useGetUser } from "@/hooks/requests/user/use-get-user";
import { memo } from "react";

type BodySegment = { text: string; bold?: boolean };

interface TipRow {
  icon: string;
  head?: string;
  body: string | BodySegment[];
}

const TIPS: TipRow[] = [
  {
    icon: "/assets/images/chat-welcome/tip-eat.svg",
    head: "You tell me what you fancy eating -",
    body: "I'll take care of the nutrition behind the scenes",
  },
  {
    icon: "/assets/images/chat-welcome/tip-nutrition.svg",
    body: [
      { text: "I'll make sure the " },
      { text: "calories, protein and everything else", bold: true },
      {
        text: " are where they need to be, so you can stay on track without constantly thinking about food.",
      },
    ],
  },
  {
    icon: "/assets/images/chat-welcome/tip-lifestyle.svg",
    body: [
      { text: "Include your " },
      { text: "favourite brands, meals, coffees, snacks, or things on the go", bold: true },
      { text: " - I'll build everything around your lifestyle." },
    ],
  },
];

const renderBody = (body: TipRow["body"]) => {
  if (typeof body === "string") return body;
  return body.map((seg, i) =>
    seg.bold ? (
      <span key={i} className="font-bold">
        {seg.text}
      </span>
    ) : (
      <span key={i}>{seg.text}</span>
    ),
  );
};

export const ChatWelcomeState = memo(function ChatWelcomeState() {
  const { user } = useGetUser();
  const firstName = user?.personalInfo?.firstName?.trim();

  return (
    <div className="flex w-full flex-col gap-[45px] text-black">
      <div className="flex flex-col gap-6">
        <p className="text-base leading-6 font-bold">
          {firstName ? `Hi ${firstName}, welcome - ` : "Hi, welcome - "}I&apos;m NutriCoach{" "}
          <span aria-hidden>💜</span>
        </p>
        <p className="text-base leading-6 font-medium">
          I&apos;m here to make nutrition feel simpler, less stressful, and completely built around
          you.
        </p>
      </div>

      <div className="flex flex-col gap-9">
        {TIPS.map((tip, i) => (
          <div key={i} className="flex w-full items-center gap-3">
            <img src={tip.icon} alt="" className="size-[59px] shrink-0 object-contain" />
            <div className="flex flex-1 flex-col gap-3 text-sm">
              {tip.head && <p className="font-bold">{tip.head}</p>}
              <p className="font-medium">{renderBody(tip.body)}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-6">
        <p className="text-base leading-6 font-bold">
          You&apos;re all set. Let&apos;s get to your plan <span aria-hidden>✨</span>
        </p>
        <p className="text-base leading-6 font-medium">
          Do you have any questions for me? I&apos;m here to help. <span aria-hidden>💜</span>
        </p>
      </div>
    </div>
  );
});
